"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeTimeoutSignal = void 0;
/**
 * This method generates an AbortSignal to attach to a request.
 * It does some extremely cautious checks to determine what is supported
 * @todo replace this with an AbortSignal.timeout polyfill
 *
 * @param timeoutMillis - the number of millis to wait before timing out
 * @returns an instance of AbortSignal if it can find a supported way to do it, otherwise undefined
 */
const safeTimeoutSignal = (timeoutMillis) => {
    if ('AbortSignal' in global && 'timeout' in AbortSignal) {
        return AbortSignal.timeout(timeoutMillis);
    }
    if ('AbortController' in global) {
        const abortController = new AbortController();
        setTimeout(() => abortController.abort(), timeoutMillis);
        return abortController.signal;
    }
    return undefined;
};
exports.safeTimeoutSignal = safeTimeoutSignal;
